import { Injectable } from '@angular/core';
import { lightTheme, CSSVarType } from '@shared/theme/common.colors';
import { primeNg_strings } from '@shared/strings/common.strings';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private isDark = false;

  setTheme(theme: CSSVarType) {
    // theme for primeng
    const element = document.querySelector('html');
    if (this.isDark) {
      element!.classList.add(primeNg_strings.dark_mode_class_name);
    } else {
      element!.classList.remove(primeNg_strings.dark_mode_class_name);
    }
    // global theme
    const root = document.documentElement;
    for (const key in theme) {
      root.style.setProperty(key, theme[key]);
    }
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    this.setTheme(this.isDark ? lightTheme : lightTheme);
    localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
  }

  initTheme() {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      this.isDark = true;
      this.setTheme(lightTheme);
    } else {
      this.isDark = false;
      this.setTheme(lightTheme);
    }
  }

  getCurrentTheme(): CSSVarType {
    return this.isDark ? lightTheme : lightTheme;
  }
}
